import { z } from 'zod';
import { inferApiResultSchema, inferPaginatedApiResponse } from './infer-api';

export const ContactSchema = z.object({
  id: z.number(),
  accountId: z.string().max(50),
  customerId: z.number(),
  email: z.string().email(),
  firstName: z.string().trim(),
  lastName: z.string().trim(),
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.coerce.date().nullish(),
  archivedAt: z.coerce.date().nullish(),
});

export type ContactDto = z.infer<typeof ContactSchema>;

// POST /v1/contacts

export const CreateContactSchema = ContactSchema.omit({
  id: true,
  accountId: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
});
export type CreateContactDto = z.infer<typeof CreateContactSchema>;

export const CreateContactsSchema = CreateContactSchema.array();

export type CreateContactsDto = z.infer<typeof CreateContactsSchema>;

export const UpdateContactSchema = ContactSchema.omit({
  id: true,
  accountId: true,
  createdAt: true,
  updatedAt: true,
}).partial();
export type UpdateContactDto = z.infer<typeof UpdateContactSchema>;

export const CreateContactResponseSchema = z.object({
  data: ContactSchema,
});
export type CreateContactResponseDto = z.infer<typeof CreateContactResponseSchema>;

export const ContactSortSchema = z.object({
  column: ContactSchema.omit({
    accountId: true,
  })
    .keyof()
    .default('createdAt'),
  order: z.enum(['asc', 'desc']).default('desc'),
});
export type ContactSortDto = z.infer<typeof ContactSortSchema>;

export const ContactFilterSchema = ContactSchema.omit({
  updatedAt: true,
  createdAt: true,
  customerId: true,
  accountId: true,
}).partial();
export type ContactFilterDto = z.infer<typeof ContactFilterSchema>;

// GET /api/v1/customers/:id/contacts
export const GetCustomerContactsResponseSchema = inferPaginatedApiResponse(z.array(ContactSchema));
export type GetCustomerContactsResponseDto = z.infer<typeof GetCustomerContactsResponseSchema>;

// GET /api/v1/contacts/by-ids
export const GetContactsByIdsResponseSchema = inferApiResultSchema(z.array(ContactSchema));
export type GetContactsByIdsResponseDto = z.infer<typeof GetContactsByIdsResponseSchema>;

// PUT /api/v1/customers/:customerId/contacts/:contactId
export const UpdateCustomerContactSchema = ContactSchema.omit({
  id: true,
  accountId: true,
  createdAt: true,
  updatedAt: true,
}).partial();
export type UpdateCustomerContactDto = z.infer<typeof UpdateCustomerContactSchema>;

export const UpdateCustomerContactResponseSchema = inferApiResultSchema(ContactSchema);
export type UpdateCustomerContactResponseDto = z.infer<typeof UpdateCustomerContactResponseSchema>;
